import React from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";

/**
 * Recording alert modal shown when a meeting recording starts.
 * Displays rejoin guidance for hosts and guests.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.show - Whether the modal is visible.
 * @param {Function} props.handleClose - Callback when the modal is closed.
 * @param {boolean} props.isHost - True when the viewer is the logged-in host.
 * @returns {JSX.Element} Recording alert modal.
 */
const RecordingModal = ({ handleClose, show, isHost }) => {
  return (
    <div className="recording-popup-modal">
      <Modal
        size={"sm"}
        show={show}
        onHide={handleClose}
        animation={false}
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ width: "100%" }}>Recording alert</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <h4 className="fw-bold text-dark mb-2">
            The Meeting is Being Recorded
          </h4>

          <p className="text-secondary" style={{ fontSize: "15px" }}>
            {isHost ? (
              <>
                If you need to leave this call and return to it,{" "}
                <strong>do not hang up.</strong> Simply close your browser or
                app and rejoin from your <strong>Meetings tab</strong>.
              </>
            ) : (
              <>
                If you need to leave this call and return to it, you can{" "}
                <strong>hang up</strong> and rejoin using the{" "}
                <strong>meeting link</strong> sent to your email or text
                message.
              </>
            )}
          </p>
        </Modal.Body>
      </Modal>
    </div>
  );
};

RecordingModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  isHost: PropTypes.bool.isRequired,
};

export default RecordingModal;